import React, { useEffect } from "react";
import { Spin } from "antd";
import "./style.scss";

const Loader = ({ spinning = false, fullScreen, children, style }) => {
  useEffect(() => {
    if (fullScreen) {
      // Disable scroll and selection
      document.body.style.overflow = "hidden";
      document.body.style.userSelect = "none";
    }

    // Re-enable on unmount
    return () => {
      document.body.style.overflow = "";
      document.body.style.userSelect = "";
    };
  }, []);

  return (
    <Spin
      style={style}
      fullscreen={fullScreen}
      size="large"
      spinning={spinning}
    >
      {children}
    </Spin>
  );
};

export default Loader;
